import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    this.id = this.element.id
    this.trigger = document.querySelector(`[data-dialog-target="${this.id}"]`)
    document.addEventListener("ui:dialog:open", this.#handleOpen)
  }

  disconnect () {
    document.removeEventListener("ui:dialog:open", this.#handleOpen)
  }

  open () {
    this.element.classList.remove("hidden")
    this.trigger.disabled = true
  }

  close () {
    this.element.classList.add("hidden")
    this.trigger.disabled = false
  }

  #handleOpen = (event) => {
    if (event.detail.id === this.id) {
      this.open()
    }
  }
}
